import axios from 'axios';

//const baseUrl = 'http://localhost/api/v1.0/';
const baseUrl = 'https://leopos.com.br/api/v1.0/';
export const api = axios.create({baseURL:baseUrl});
//export default api;

const baseUrlraiz = 'https://leopos.com.br/';
//const baseUrlraiz = 'http://localhost/';

const baseUrlViaCep = 'https://viacep.com.br/ws/';
export const apiviacep = axios.create({baseURL:baseUrlViaCep});
//export default viacep;


//PAGAR.ME export const ENCRYPT_KEY =   "ek_test_kSsao2ZIDvQwezLlAAJOYda7RGKJqY"; 
export const ENCRYPT_KEY =   "ek_live_CLweNIoV6kVsfsmxjZ5VucBXi1e0Iz";

//MERCADOPAGO
export const MP_PUBLIC_KEY = 'APP_USR-928324a9-5946-4b16-8e00-25d1c1956546'
export const MP_ID = "23856490837356"

export const BASEURL = baseUrl
export const BASEURLRAIZ = baseUrlraiz

export const BASEURLSITE = 'http://192.168.1.4:5002/'


